export const USER_ADMIN_ROLE = 'goplan_admin';
export const USER_EDITOR_ROLE = 'goplan_editor';
